export default __webpack_public_path__ + "static/9-neon-sign-302e085e0d6f628f10fa5a88566d3998.png";